import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, XCircle } from 'lucide-react';
import { SectionWrapper } from './ui/SectionWrapper';
export function ForWho() {
  return <SectionWrapper background="slate" data-id="element-133">
      <div className="text-center mb-12" data-id="element-134">
        <h2 className="text-3xl font-bold text-slate-900" data-id="element-135">¿Es para ti?</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-136">
        {/* For You */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-emerald-50 border border-emerald-200 rounded-2xl p-8" data-id="element-137">
          <h3 className="text-xl font-bold text-emerald-800 mb-6" data-id="element-138">
            Este ebook ES para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-139">
            {['Eres principiante y quieres un punto de partida claro', 'Quieres evitar los errores más caros antes de invertir', 'Vives fuera de USA y quieres vender en Amazon.com', 'Quieres elegir el modelo correcto según tu presupuesto real'].map((item, i) => <li key={i} className="flex items-start gap-3 text-emerald-900/80" data-id="element-140">
                <CheckCircle className="h-5 w-5 text-emerald-600 flex-shrink-0 mt-0.5" data-id="element-141" />
                <span data-id="element-142">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        {/* Not For You */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="bg-red-50 border border-red-200 rounded-2xl p-8" data-id="element-143">
          <h3 className="text-xl font-bold text-red-800 mb-6" data-id="element-144">
            NO es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-145">
            {['Buscas dinero rápido sin esfuerzo ni investigación', 'Quieres atajos que violen las políticas de Amazon', 'No estás dispuesto/a a investigar, probar y ajustar'].map((item, i) => <li key={i} className="flex items-start gap-3 text-red-900/80" data-id="element-146">
                <XCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-147" />
                <span data-id="element-148">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </SectionWrapper>;
}